'use client';

import Image from 'next/image';
import Link from 'next/link';
import Problem from '@/components/enterprise/Problem';
import Solution from '@/components/enterprise/Solution';
import CallToAction from '@/components/enterprise/CallToAction';
import Footer from '@/components/Footer';

export default function EnterprisePage() {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex flex-col md:flex-row">
        <Link href="/">
          <Image
              src="https://storage.googleapis.com/saved_media_assets/Saved%20Logo%20Square.png"
              alt="Saved Logo"
              width={24}
              height={24}
              className="absolute top-6 left-6 md:top-10 md:left-10 md:w-[30px] md:h-[30px] z-10"
          />
        </Link>
        {/* Left Column */}
        <div className="relative w-full md:w-1/3 bg-black text-white flex flex-col justify-end p-6 md:p-8 md:border-r border-white/20 order-2 md:order-none min-h-[50vh] md:min-h-screen">
          <div className="max-w-xl mb-6 md:mb-10">
            <h1 className="text-4xl md:text-6xl font-black leading-tight md:leading-tighter mb-4 md:mb-6">
              Run organic
              <br />
              ads at scale.
            </h1>
            <p className="text-md md:text-xl leading-normal mb-6 md:mb-8 text-white/60 font-regular">
              Automated UGC campaigns, end to end.<br />
              Never run paid Ads again.
            </p>
            <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-4">
              <a href="http://calendly.com/aayushgupta-startupshell/30min?month=2025-04" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto bg-white text-black font-bold py-3 px-5 hover:bg-gray-200 transition-colors text-lg md:text-xl text-center inline-block">
                Get Started
              </a>
              <button 
                onClick={() => document.getElementById('problem')?.scrollIntoView({ behavior: 'smooth' })}
                className="w-full md:w-auto bg-transparent text-white font-bold border border-white/20 py-3 px-5 hover:bg-white/5 transition-colors text-lg md:text-xl"
              >
                Learn More
              </button>
            </div>
          </div>
        </div>

        {/* Right Column (Image) */}
        <div className="relative w-full md:w-2/3 h-64 md:h-auto order-1 md:order-none min-h-[50vh] md:min-h-screen">
          <Image
            src="https://storage.googleapis.com/saved_media_assets/b2b-background.avif"
            alt="Background"
            layout="fill"
            objectFit="cover"
            quality={80}
          />
        </div>
      </div>
      <div id="problem" className="border-t border-[#2a2a2a]">
        <Problem />
      </div>
      <div id="solution" className="">
        <Solution />
      </div>
      <div className="border-t border-[#2a2a2a]">
        <CallToAction />
      </div>
      <Footer />
    </div>
  );
}
